import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w-[90%] lg:w-[390px] mx-auto py-14" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4 space-y-4 text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-primary-500" }, "Confirm Booking")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Your booking appointment has been received.", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "A medical questionnaire has been provided in your appointment details, which you may access by clicking the button below. Please ensure that this form has been filled before your appointment.", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Thank you!", -1)

import UserLayout from '@/layouts/UserLayout.vue';
import BookingSummary from '@/components/cards/BookingSummary.vue';
import GeneralModal from '@/components/GeneralModal.vue';
import { ref, onMounted } from "vue";
import { useRouter } from 'vue-router';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import Storage from '@/helpers/storage';
import booking from "@/classes/Booking";
import { useBookingStore } from '@/store/booking';
import { getActivePinia } from "pinia"

// Router Instance

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmBooking',
  setup(__props) {

const router = useRouter();

// State Instance
const bookingStoreState = useBookingStore();

// Local Storage Instance
const bookingLocalStorage = new Storage();
const bookingLocalStoragePayload = ref(JSON.parse(bookingLocalStorage.get('bookingPayload')));
const bookingLocalStorageSummary = ref(JSON.parse(bookingLocalStorage.get('bookingSummary')));
const bookingLocalStorageCanSubmitBooking = ref(JSON.parse(bookingLocalStorage.get('canSubmitBooking')));

// Data
const loader = ref(false);
const showError = ref(false);
const errorMsg = ref(null);
const errors      = ref([])
const show = ref(false);
const bookingId = ref(null)

const submitBooking = () => {
    loader.value = true;
    
    booking.submitBooking(bookingStoreState.bookingPayload)
    .then((result: any) => {
            loader.value = false;
            
            
            if(result.data.response.result_status == 500) {
                showError.value = true;
                errorMsg.value = "Something went wrong. Please try again later";
                
                return;
            }
            
            show.value = true;
            bookingId.value = result.data.response.response.booking_id;
            
            // Clear State and Local Storage After Success Booking
            bookingLocalStorage.clearItems(['bookingPayload', 'bookingSummary', 'canSubmitBooking']);
            getActivePinia()._s.forEach(store => store.$reset());
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;

            if(err.response.status == 422) {
                errors.value = err.response.data.errors;
            }

            if(err.response.status == 401) {
                window.location.replace('/login')
            }
        })
}

const fetchDrafts = () => {
    bookingStoreState.bookingPayload = bookingLocalStoragePayload.value || bookingStoreState.bookingPayload;
    bookingStoreState.bookingSummary = bookingLocalStorageSummary.value || bookingStoreState.bookingSummary;
    bookingStoreState.canSubmitBooking = bookingLocalStorageCanSubmitBooking.value || bookingStoreState.canSubmitBooking;
}

const bookAnother = () => {
    window.location.href = '/booking'
}
const viewBoking = () => {
    show.value = false
    window.location.replace(`/appointment/show/${bookingId.value}`);
}


onMounted( () => {
    fetchDrafts();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", null, [
          _createVNode(BookingSummary, {
            totalColor: "text-primary-500",
            onBookNow: submitBooking
          }),
          _createElementVNode("p", {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(router).push('/booking/select-date-and-time')), ["prevent"])),
            class: "mt-4 text-center cursor-pointer text-primary-500"
          }, "Edit Appointment")
        ])
      ]),
      _createVNode(GeneralModal, {
        width: "w-[548px]",
        "check-icon": "",
        title: "Booking Confirmed!",
        "action-text": "View Appointment",
        "cancel-text": "Book another",
        show: show.value,
        onClose: bookAnother,
        onConfirm: viewBoking
      }, {
        content: _withCtx(() => [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _hoisted_7
        ]),
        _: 1
      }, 8, ["show"]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[2] || (_cache[2] = ($event: any) => (showError.value = false)),
        errors: errors.value
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show", "errors"])
    ]),
    _: 1
  }))
}
}

})